export const DEAL_FETCH_MAX_ATTEMPTS = 2;

export function shouldRetryDealFetchError(error: unknown) {
  const code = String((error as { code?: unknown } | null)?.code ?? "");
  if (/^\d{3}$/.test(code)) {
    const status = Number(code);
    return status >= 500 && status < 600;
  }
  if ([
    "ConnectionRefused",
    "ECONNRESET",
    "ETIMEDOUT",
    "FailedToOpenSocket",
  ].includes(code)) {
    return true;
  }
  const message = String(
    (error as { message?: unknown } | null)?.message ?? "",
  );
  return /failed to fetch|fetch failed|network error|connection (?:reset|refused)|timed? ?out/i
    .test(message);
}
